import { FieldValidationState } from '@payaca/ambrosia';
import { FieldError, FieldErrors, get } from 'react-hook-form';

type RegisterFieldProps = {
  name: string;
  validationState?: FieldValidationState;
};

/**
 * Returns a function that behaves like react-hook-form's register function, but for our Field.Legacy component
 */
export const registerFieldLegacyBuilder =
  (errors: FieldErrors) =>
  (name: string): RegisterFieldProps => {
    const fieldError = get(errors, name) as FieldError | undefined;

    if (!fieldError || Array.isArray(fieldError)) {
      return {
        name,
      };
    }

    return {
      name,
      validationState: {
        isValid: false,
        validationMessages: [
          fieldError.message ||
            fieldError.root?.message ||
            `Unknown error: ${fieldError.type}`,
        ],
      },
    };
  };
